/**
 * Formatadores específicos da feature de badges.
 *
 * Mantido aqui (e não em utils globais) porque por enquanto só a tela
 * de admin de badges consome — se virar comum, migra pra @/utils/date.
 */

/**
 * Converte uma string ISO (ou um YYYY-MM-DD) pra DD/MM/AAAA (padrão BR).
 *
 * Entrada vem do back em formato ISO datetime (`2026-05-25T00:00:00.000Z`)
 * porque o campo é Prisma DateTime. Front exibia o ISO crú no
 * `summarizeWindow` em `between` e `specific_date` — bug visual da F3
 * reportado pelo usuário, fix da Sprint Tech Debt (TD1).
 *
 * Retorna '—' pra qualquer entrada que não bate o regex `YYYY-MM-DD...`,
 * pra evitar quebrar a UI quando o back devolver algo inesperado.
 */
export function formatBrDate(iso: string): string {
  if (!iso || typeof iso !== 'string') return '—'
  // Aceita 'YYYY-MM-DD' ou 'YYYY-MM-DDTHH:MM:SS...' (ISO datetime)
  const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) return '—'
  const [, year, month, day] = match
  return `${day}/${month}/${year}`
}

/**
 * Variante de `formatBrDate` que usa traços (DD-MM-YYYY) em vez de
 * barras. Preferência explícita do user (2026-05-14) só pro preview
 * lateral do `BadgeFormDialog` no admin. `BadgesCard` (perfil do
 * usuário) continua usando `formatBrDate` (DD/MM/AAAA).
 */
export function formatBrDateDashed(iso: string): string {
  if (!iso || typeof iso !== 'string') return '—'
  const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) return '—'
  const [, year, month, day] = match
  return `${day}-${month}-${year}`
}

/**
 * Converte ISO datetime / YYYY-MM-DD pra string que `<input type="date">`
 * aceita (`YYYY-MM-DD` exato). Quando o back devolve uma badge com
 * `windowStart: '2026-01-01T00:00:00.000Z'` e o React tenta encher um
 * date input, o browser rejeita silenciosamente o ISO completo e o
 * input vira placeholder vazio. Esse helper resolve.
 *
 * Retorna `''` (string vazia) pra entradas inválidas — o input fica
 * limpo, mas não quebra (controlled input precisa string, não undefined).
 */
export function toDateInputValue(iso: string): string {
  if (!iso || typeof iso !== 'string') return ''
  const match = iso.match(/^(\d{4}-\d{2}-\d{2})/)
  return match ? match[1] : ''
}
